import React from 'react';
import { FieldErrorProps } from '@rjsf/utils';
import { AttentionIcon } from 'shared/components/ui/ProjectIcons';

// A field's errors in the same orange line generateUISchema gives top-level
// fields, for the ones it cannot reach (fields inside list rows).
const CustomFieldErrorTemplate = ({ errors, idSchema }: FieldErrorProps) => {
  const messages = (errors ?? []).filter(
    (error): error is string => typeof error === 'string' && error !== '',
  );
  if (!messages.length) return null;
  return (
    <div id={`${idSchema.$id}__error`} data-testid="SchemaForm-field-error">
      {messages.map((message) => (
        <div
          key={message}
          className="flex flex-row items-center rounded py-1 text-ui-status-error-destructive"
        >
          <AttentionIcon /> <p className="ml-1 mt-0.5">{message}</p>
        </div>
      ))}
    </div>
  );
};

export default CustomFieldErrorTemplate;
